<script setup>
import { computed } from 'vue'
import { useStore } from "vuex";
import ProgramManagerV2 from "@/components/program-manager/v2";
import ProgramManager from "@/components/program-manager";

const store = useStore();
const showNewSessionSearch = computed(() => {
  const featureFlags = store.state.featureFlags;
  return featureFlags["new-sessions-search"];
});
</script>

<template>
  <div>
    <ProgramManagerV2 v-if="showNewSessionSearch"/>
    <ProgramManager v-else/>
  </div>
</template>
